// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/preset/v1/ai_provider.proto (package creativefabrica.preset.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Surface, SurfaceJson } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import { file_creativefabrica_common_v1_surface_v1_types } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import type { CoinConfig, CoinConfigJson, CoinPricingType, CoinPricingTypeJson, ConstraintRule, ConstraintRuleJson, FieldDescriptor, FieldDescriptorJson, FieldValue, FieldValueJson, Modality, ModalityJson, OutputType, OutputTypeJson, RoleConstraint, RoleConstraintJson } from "./types_pb";
import { file_creativefabrica_preset_v1_types } from "./types_pb";
import { file_google_api_annotations } from "@repo/rpc-types-google-api/annotations";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/preset/v1/ai_provider.proto.
 */
export const file_creativefabrica_preset_v1_ai_provider: GenFile = /*@__PURE__*/
  fileDesc("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", [file_creativefabrica_common_v1_surface_v1_types, file_creativefabrica_preset_v1_types, file_google_api_annotations]);

/**
 * AIProvider represents a provider with its available models.
 *
 * @generated from message creativefabrica.preset.v1.AIProvider
 */
export type AIProvider = Message<"creativefabrica.preset.v1.AIProvider"> & {
  /**
   * e.g. "gemini", "elevenlabs", "stability_ai"
   *
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: repeated creativefabrica.preset.v1.AIModel models = 3;
   */
  models: AIModel[];
};

/**
 * AIProvider represents a provider with its available models.
 *
 * @generated from message creativefabrica.preset.v1.AIProvider
 */
export type AIProviderJson = {
  /**
   * e.g. "gemini", "elevenlabs", "stability_ai"
   *
   * @generated from field: string provider = 1;
   */
  provider?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: repeated creativefabrica.preset.v1.AIModel models = 3;
   */
  models?: AIModelJson[];
};

/**
 * Describes the message creativefabrica.preset.v1.AIProvider.
 * Use `create(AIProviderSchema)` to create a new message.
 */
export const AIProviderSchema: GenMessage<AIProvider, {jsonType: AIProviderJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 0);

/**
 * AIModel is lightweight model metadata returned in provider listings.
 *
 * @generated from message creativefabrica.preset.v1.AIModel
 */
export type AIModel = Message<"creativefabrica.preset.v1.AIModel"> & {
  /**
   * e.g. "gemini_pro_3", "gemini_veo"
   *
   * @generated from field: string model = 1;
   */
  model: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: repeated creativefabrica.preset.v1.Modality supported_modalities = 3;
   */
  supportedModalities: Modality[];
};

/**
 * AIModel is lightweight model metadata returned in provider listings.
 *
 * @generated from message creativefabrica.preset.v1.AIModel
 */
export type AIModelJson = {
  /**
   * e.g. "gemini_pro_3", "gemini_veo"
   *
   * @generated from field: string model = 1;
   */
  model?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: repeated creativefabrica.preset.v1.Modality supported_modalities = 3;
   */
  supportedModalities?: ModalityJson[];
};

/**
 * Describes the message creativefabrica.preset.v1.AIModel.
 * Use `create(AIModelSchema)` to create a new message.
 */
export const AIModelSchema: GenMessage<AIModel, {jsonType: AIModelJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 1);

/**
 * AIModelCapabilities describes the full set of options and constraints a model supports.
 * This is the superset — preset version model configs select a narrowed subset.
 *
 * @generated from message creativefabrica.preset.v1.AIModelCapabilities
 */
export type AIModelCapabilities = Message<"creativefabrica.preset.v1.AIModelCapabilities"> & {
  /**
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: string model = 2;
   */
  model: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated creativefabrica.preset.v1.Modality supported_modalities = 4;
   */
  supportedModalities: Modality[];

  /**
   * The full set of user-selectable parameters this model supports.
   * Preset authors pick a subset of these when creating a preset version model config.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldDescriptor> input_options = 5;
   */
  inputOptions: { [key: string]: FieldDescriptor };

  /**
   * Flat per-file limits for flat-file modalities (image_to_image etc.).
   * Preset version model configs must be equal to or stricter than these — never looser.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldDescriptor> input_constraints = 6;
   */
  inputConstraints: { [key: string]: FieldDescriptor };

  /**
   * Default coin pricing for direct generations (no preset).
   * Preset-based generations use preset_version_model_configs.coin_config instead.
   *
   * @generated from field: creativefabrica.preset.v1.CoinConfig default_coin_config = 7;
   */
  defaultCoinConfig?: CoinConfig | undefined;

  /**
   * Per-role file limits for role-keyed modalities (media_to_video).
   * Preset version model configs must be equal to or stricter than these — never looser.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.RoleConstraint> input_role_constraints = 8;
   */
  inputRoleConstraints: { [key: string]: RoleConstraint };

  /**
   * Cross-role validation rules the model supports (see ConstraintRule).
   *
   * @generated from field: repeated creativefabrica.preset.v1.ConstraintRule input_constraint_rules = 9;
   */
  inputConstraintRules: ConstraintRule[];

  /**
   * Which request inputs determine this model's price (dynamic pricing only).
   * Unset for static-priced models and for flat-rate dynamic models — check
   * default_coin_config.pricing_type to tell the two apart.
   *
   * @generated from field: creativefabrica.preset.v1.PricingInputs pricing_inputs = 10;
   */
  pricingInputs?: PricingInputs | undefined;

  /**
   * Studio Asset reference caps; unset = model accepts no Studio Asset
   * references.
   *
   * @generated from field: creativefabrica.preset.v1.AssetReferenceCaps asset_references = 11;
   */
  assetReferences?: AssetReferenceCaps | undefined;

  /**
   * Maximum prompt text length in characters (Unicode code points) the model
   * accepts. Unset = the model publishes no prompt-length limit. Informational
   * catalog metadata only — genAI does not enforce it at generate time.
   *
   * @generated from field: optional int32 max_prompt_length = 12;
   */
  maxPromptLength?: number | undefined;

  /**
   * Identifier of the voice catalog this model draws its speaker voices from
   * (e.g. "byteplus_seed_tts_2"). Pass it as VoicesService.ListVoices'
   * voice_catalog to enumerate the voices valid for this model. Unset = the
   * model has no voice selection. A voice id is only valid on the catalog it
   * came from, so never reuse ids across catalogs.
   *
   * @generated from field: optional string voice_catalog = 13;
   */
  voiceCatalog?: string | undefined;
};

/**
 * AIModelCapabilities describes the full set of options and constraints a model supports.
 * This is the superset — preset version model configs select a narrowed subset.
 *
 * @generated from message creativefabrica.preset.v1.AIModelCapabilities
 */
export type AIModelCapabilitiesJson = {
  /**
   * @generated from field: string provider = 1;
   */
  provider?: string;

  /**
   * @generated from field: string model = 2;
   */
  model?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: repeated creativefabrica.preset.v1.Modality supported_modalities = 4;
   */
  supportedModalities?: ModalityJson[];

  /**
   * The full set of user-selectable parameters this model supports.
   * Preset authors pick a subset of these when creating a preset version model config.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldDescriptor> input_options = 5;
   */
  inputOptions?: { [key: string]: FieldDescriptorJson };

  /**
   * Flat per-file limits for flat-file modalities (image_to_image etc.).
   * Preset version model configs must be equal to or stricter than these — never looser.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldDescriptor> input_constraints = 6;
   */
  inputConstraints?: { [key: string]: FieldDescriptorJson };

  /**
   * Default coin pricing for direct generations (no preset).
   * Preset-based generations use preset_version_model_configs.coin_config instead.
   *
   * @generated from field: creativefabrica.preset.v1.CoinConfig default_coin_config = 7;
   */
  defaultCoinConfig?: CoinConfigJson;

  /**
   * Per-role file limits for role-keyed modalities (media_to_video).
   * Preset version model configs must be equal to or stricter than these — never looser.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.RoleConstraint> input_role_constraints = 8;
   */
  inputRoleConstraints?: { [key: string]: RoleConstraintJson };

  /**
   * Cross-role validation rules the model supports (see ConstraintRule).
   *
   * @generated from field: repeated creativefabrica.preset.v1.ConstraintRule input_constraint_rules = 9;
   */
  inputConstraintRules?: ConstraintRuleJson[];

  /**
   * Which request inputs determine this model's price (dynamic pricing only).
   * Unset for static-priced models and for flat-rate dynamic models — check
   * default_coin_config.pricing_type to tell the two apart.
   *
   * @generated from field: creativefabrica.preset.v1.PricingInputs pricing_inputs = 10;
   */
  pricingInputs?: PricingInputsJson;

  /**
   * Studio Asset reference caps; unset = model accepts no Studio Asset
   * references.
   *
   * @generated from field: creativefabrica.preset.v1.AssetReferenceCaps asset_references = 11;
   */
  assetReferences?: AssetReferenceCapsJson;

  /**
   * Maximum prompt text length in characters (Unicode code points) the model
   * accepts. Unset = the model publishes no prompt-length limit. Informational
   * catalog metadata only — genAI does not enforce it at generate time.
   *
   * @generated from field: optional int32 max_prompt_length = 12;
   */
  maxPromptLength?: number;

  /**
   * Identifier of the voice catalog this model draws its speaker voices from
   * (e.g. "byteplus_seed_tts_2"). Pass it as VoicesService.ListVoices'
   * voice_catalog to enumerate the voices valid for this model. Unset = the
   * model has no voice selection. A voice id is only valid on the catalog it
   * came from, so never reuse ids across catalogs.
   *
   * @generated from field: optional string voice_catalog = 13;
   */
  voiceCatalog?: string;
};

/**
 * Describes the message creativefabrica.preset.v1.AIModelCapabilities.
 * Use `create(AIModelCapabilitiesSchema)` to create a new message.
 */
export const AIModelCapabilitiesSchema: GenMessage<AIModelCapabilities, {jsonType: AIModelCapabilitiesJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 2);

/**
 * AssetReferenceCaps declares the model's Studio Asset reference limits
 * ([c:username] / [p:username] mentions in the prompt), merged
 * most-permissively across modalities (same convention as input_constraints).
 * Unset when the model accepts no Studio Asset references at all.
 *
 * @generated from message creativefabrica.preset.v1.AssetReferenceCaps
 */
export type AssetReferenceCaps = Message<"creativefabrica.preset.v1.AssetReferenceCaps"> & {
  /**
   * Max number of distinct Studio Asset mentions per request.
   *
   * @generated from field: int32 max_assets = 1;
   */
  maxAssets: number;
};

/**
 * AssetReferenceCaps declares the model's Studio Asset reference limits
 * ([c:username] / [p:username] mentions in the prompt), merged
 * most-permissively across modalities (same convention as input_constraints).
 * Unset when the model accepts no Studio Asset references at all.
 *
 * @generated from message creativefabrica.preset.v1.AssetReferenceCaps
 */
export type AssetReferenceCapsJson = {
  /**
   * Max number of distinct Studio Asset mentions per request.
   *
   * @generated from field: int32 max_assets = 1;
   */
  maxAssets?: number;
};

/**
 * Describes the message creativefabrica.preset.v1.AssetReferenceCaps.
 * Use `create(AssetReferenceCapsSchema)` to create a new message.
 */
export const AssetReferenceCapsSchema: GenMessage<AssetReferenceCaps, {jsonType: AssetReferenceCapsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 3);

/**
 * PricingInputs declares which CalculateModelCost inputs determine a dynamic
 * model's price. Clients should collect exactly these before requesting a
 * quote — all of them are required and defaults are never applied.
 *
 * @generated from message creativefabrica.preset.v1.PricingInputs
 */
export type PricingInputs = Message<"creativefabrica.preset.v1.PricingInputs"> & {
  /**
   * input_options keys that affect the price, e.g. ["duration_seconds", "resolution"].
   *
   * @generated from field: repeated string options = 1;
   */
  options: string[];

  /**
   * Input-file roles whose metadata affects the price.
   *
   * @generated from field: repeated creativefabrica.preset.v1.PricingMediaInput media = 2;
   */
  media: PricingMediaInput[];
};

/**
 * PricingInputs declares which CalculateModelCost inputs determine a dynamic
 * model's price. Clients should collect exactly these before requesting a
 * quote — all of them are required and defaults are never applied.
 *
 * @generated from message creativefabrica.preset.v1.PricingInputs
 */
export type PricingInputsJson = {
  /**
   * input_options keys that affect the price, e.g. ["duration_seconds", "resolution"].
   *
   * @generated from field: repeated string options = 1;
   */
  options?: string[];

  /**
   * Input-file roles whose metadata affects the price.
   *
   * @generated from field: repeated creativefabrica.preset.v1.PricingMediaInput media = 2;
   */
  media?: PricingMediaInputJson[];
};

/**
 * Describes the message creativefabrica.preset.v1.PricingInputs.
 * Use `create(PricingInputsSchema)` to create a new message.
 */
export const PricingInputsSchema: GenMessage<PricingInputs, {jsonType: PricingInputsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 4);

/**
 * PricingMediaInput names an input-file role whose metadata affects the price.
 * The semantics are per file: every submitted file with this role must carry
 * the listed metadata. Allowed file counts per role are declared by the
 * model's input_role_constraints, not here.
 *
 * @generated from message creativefabrica.preset.v1.PricingMediaInput
 */
export type PricingMediaInput = Message<"creativefabrica.preset.v1.PricingMediaInput"> & {
  /**
   * e.g. "sourceVideo"
   *
   * @generated from field: string role = 1;
   */
  role: string;

  /**
   * CostMediaMetadata fields that must be set, as JSON field names:
   * "durationSeconds", "widthPx", "heightPx".
   *
   * @generated from field: repeated string required_metadata = 2;
   */
  requiredMetadata: string[];
};

/**
 * PricingMediaInput names an input-file role whose metadata affects the price.
 * The semantics are per file: every submitted file with this role must carry
 * the listed metadata. Allowed file counts per role are declared by the
 * model's input_role_constraints, not here.
 *
 * @generated from message creativefabrica.preset.v1.PricingMediaInput
 */
export type PricingMediaInputJson = {
  /**
   * e.g. "sourceVideo"
   *
   * @generated from field: string role = 1;
   */
  role?: string;

  /**
   * CostMediaMetadata fields that must be set, as JSON field names:
   * "durationSeconds", "widthPx", "heightPx".
   *
   * @generated from field: repeated string required_metadata = 2;
   */
  requiredMetadata?: string[];
};

/**
 * Describes the message creativefabrica.preset.v1.PricingMediaInput.
 * Use `create(PricingMediaInputSchema)` to create a new message.
 */
export const PricingMediaInputSchema: GenMessage<PricingMediaInput, {jsonType: PricingMediaInputJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 5);

/**
 * @generated from message creativefabrica.preset.v1.ListProvidersRequest
 */
export type ListProvidersRequest = Message<"creativefabrica.preset.v1.ListProvidersRequest"> & {
};

/**
 * @generated from message creativefabrica.preset.v1.ListProvidersRequest
 */
export type ListProvidersRequestJson = {
};

/**
 * Describes the message creativefabrica.preset.v1.ListProvidersRequest.
 * Use `create(ListProvidersRequestSchema)` to create a new message.
 */
export const ListProvidersRequestSchema: GenMessage<ListProvidersRequest, {jsonType: ListProvidersRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 6);

/**
 * @generated from message creativefabrica.preset.v1.ListProvidersResponse
 */
export type ListProvidersResponse = Message<"creativefabrica.preset.v1.ListProvidersResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.preset.v1.AIProvider providers = 1;
   */
  providers: AIProvider[];
};

/**
 * @generated from message creativefabrica.preset.v1.ListProvidersResponse
 */
export type ListProvidersResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.preset.v1.AIProvider providers = 1;
   */
  providers?: AIProviderJson[];
};

/**
 * Describes the message creativefabrica.preset.v1.ListProvidersResponse.
 * Use `create(ListProvidersResponseSchema)` to create a new message.
 */
export const ListProvidersResponseSchema: GenMessage<ListProvidersResponse, {jsonType: ListProvidersResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 7);

/**
 * @generated from message creativefabrica.preset.v1.GetModelCapabilitiesRequest
 */
export type GetModelCapabilitiesRequest = Message<"creativefabrica.preset.v1.GetModelCapabilitiesRequest"> & {
  /**
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: string model = 2;
   */
  model: string;
};

/**
 * @generated from message creativefabrica.preset.v1.GetModelCapabilitiesRequest
 */
export type GetModelCapabilitiesRequestJson = {
  /**
   * @generated from field: string provider = 1;
   */
  provider?: string;

  /**
   * @generated from field: string model = 2;
   */
  model?: string;
};

/**
 * Describes the message creativefabrica.preset.v1.GetModelCapabilitiesRequest.
 * Use `create(GetModelCapabilitiesRequestSchema)` to create a new message.
 */
export const GetModelCapabilitiesRequestSchema: GenMessage<GetModelCapabilitiesRequest, {jsonType: GetModelCapabilitiesRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 8);

/**
 * @generated from message creativefabrica.preset.v1.GetModelCapabilitiesResponse
 */
export type GetModelCapabilitiesResponse = Message<"creativefabrica.preset.v1.GetModelCapabilitiesResponse"> & {
  /**
   * @generated from field: creativefabrica.preset.v1.AIModelCapabilities capabilities = 1;
   */
  capabilities?: AIModelCapabilities | undefined;
};

/**
 * @generated from message creativefabrica.preset.v1.GetModelCapabilitiesResponse
 */
export type GetModelCapabilitiesResponseJson = {
  /**
   * @generated from field: creativefabrica.preset.v1.AIModelCapabilities capabilities = 1;
   */
  capabilities?: AIModelCapabilitiesJson;
};

/**
 * Describes the message creativefabrica.preset.v1.GetModelCapabilitiesResponse.
 * Use `create(GetModelCapabilitiesResponseSchema)` to create a new message.
 */
export const GetModelCapabilitiesResponseSchema: GenMessage<GetModelCapabilitiesResponse, {jsonType: GetModelCapabilitiesResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 9);

/**
 * @generated from message creativefabrica.preset.v1.ListModelsRequest
 */
export type ListModelsRequest = Message<"creativefabrica.preset.v1.ListModelsRequest"> & {
  /**
   * At most one filter may be set. None set = return all models.
   *
   * @generated from oneof creativefabrica.preset.v1.ListModelsRequest.filter
   */
  filter: {
    /**
     * Return only models with at least one modality that produces this output.
     *
     * @generated from field: creativefabrica.preset.v1.OutputType output_type = 1;
     */
    value: OutputType;
    case: "outputType";
  } | {
    /**
     * Return only models that support this modality.
     *
     * @generated from field: creativefabrica.preset.v1.Modality modality = 2;
     */
    value: Modality;
    case: "modality";
  } | { case: undefined; value?: undefined };

  /**
   * Also return coming-soon models (CatalogModel.coming_soon), which are
   * listed for display but refuse generation. Unset, they are omitted, so a
   * caller that does not render the flag never offers a model it cannot run.
   *
   * @generated from field: bool include_coming_soon = 3;
   */
  includeComingSoon: boolean;
};

/**
 * @generated from message creativefabrica.preset.v1.ListModelsRequest
 */
export type ListModelsRequestJson = {
  /**
   * Return only models with at least one modality that produces this output.
   *
   * @generated from field: creativefabrica.preset.v1.OutputType output_type = 1;
   */
  outputType?: OutputTypeJson;

  /**
   * Return only models that support this modality.
   *
   * @generated from field: creativefabrica.preset.v1.Modality modality = 2;
   */
  modality?: ModalityJson;

  /**
   * Also return coming-soon models (CatalogModel.coming_soon), which are
   * listed for display but refuse generation. Unset, they are omitted, so a
   * caller that does not render the flag never offers a model it cannot run.
   *
   * @generated from field: bool include_coming_soon = 3;
   */
  includeComingSoon?: boolean;
};

/**
 * Describes the message creativefabrica.preset.v1.ListModelsRequest.
 * Use `create(ListModelsRequestSchema)` to create a new message.
 */
export const ListModelsRequestSchema: GenMessage<ListModelsRequest, {jsonType: ListModelsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 10);

/**
 * @generated from message creativefabrica.preset.v1.ListModelsResponse
 */
export type ListModelsResponse = Message<"creativefabrica.preset.v1.ListModelsResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.preset.v1.CatalogModel models = 1;
   */
  models: CatalogModel[];
};

/**
 * @generated from message creativefabrica.preset.v1.ListModelsResponse
 */
export type ListModelsResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.preset.v1.CatalogModel models = 1;
   */
  models?: CatalogModelJson[];
};

/**
 * Describes the message creativefabrica.preset.v1.ListModelsResponse.
 * Use `create(ListModelsResponseSchema)` to create a new message.
 */
export const ListModelsResponseSchema: GenMessage<ListModelsResponse, {jsonType: ListModelsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 11);

/**
 * CatalogModel is a model plus everything the FE needs to render it: what it
 * produces per modality, and its full capabilities inline.
 *
 * @generated from message creativefabrica.preset.v1.CatalogModel
 */
export type CatalogModel = Message<"creativefabrica.preset.v1.CatalogModel"> & {
  /**
   * @generated from field: string model = 1;
   */
  model: string;

  /**
   * @generated from field: string provider = 2;
   */
  provider: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * Each supported modality paired with the output type it produces.
   *
   * @generated from field: repeated creativefabrica.preset.v1.ModalityOutput modality_outputs = 4;
   */
  modalityOutputs: ModalityOutput[];

  /**
   * Full configuration (options, constraints, role constraints, rules).
   *
   * @generated from field: creativefabrica.preset.v1.AIModelCapabilities capabilities = 5;
   */
  capabilities?: AIModelCapabilities | undefined;

  /**
   * URL to the model's icon/logo SVG served from the LFS CDN.
   *
   * @generated from field: string icon_url = 6;
   */
  iconUrl: string;

  /**
   * Product surfaces this model should be offered on (e.g. Studio,
   * Freemode). Empty means the model is available on all surfaces.
   *
   * @generated from field: repeated creativefabrica.common.v1.surface.v1.Surface surfaces = 7;
   */
  surfaces: Surface[];

  /**
   * One-line marketing description for the model picker UI.
   *
   * @generated from field: string short_description = 8;
   */
  shortDescription: string;

  /**
   * Public/marketing name (e.g. "Nano Banana 2"), distinct from the internal
   * display_name (e.g. "Gemini Flash 3.1").
   *
   * @generated from field: string public_model_name = 9;
   */
  publicModelName: string;

  /**
   * Unset when this model cannot be targeted by the shared Prompt Builder.
   *
   * @generated from field: creativefabrica.preset.v1.PromptBuilderSupport prompt_builder = 10;
   */
  promptBuilder?: PromptBuilderSupport | undefined;

  /**
   * coming_soon marks a pre-launch model that is listed for display (e.g. a
   * "coming soon" badge in a picker) but cannot generate yet: every generation
   * request naming it fails with INVALID_ARGUMENT. Cost quotes and
   * capabilities still resolve. Only returned when
   * ListModelsRequest.include_coming_soon is set.
   *
   * @generated from field: bool coming_soon = 11;
   */
  comingSoon: boolean;
};

/**
 * CatalogModel is a model plus everything the FE needs to render it: what it
 * produces per modality, and its full capabilities inline.
 *
 * @generated from message creativefabrica.preset.v1.CatalogModel
 */
export type CatalogModelJson = {
  /**
   * @generated from field: string model = 1;
   */
  model?: string;

  /**
   * @generated from field: string provider = 2;
   */
  provider?: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName?: string;

  /**
   * Each supported modality paired with the output type it produces.
   *
   * @generated from field: repeated creativefabrica.preset.v1.ModalityOutput modality_outputs = 4;
   */
  modalityOutputs?: ModalityOutputJson[];

  /**
   * Full configuration (options, constraints, role constraints, rules).
   *
   * @generated from field: creativefabrica.preset.v1.AIModelCapabilities capabilities = 5;
   */
  capabilities?: AIModelCapabilitiesJson;

  /**
   * URL to the model's icon/logo SVG served from the LFS CDN.
   *
   * @generated from field: string icon_url = 6;
   */
  iconUrl?: string;

  /**
   * Product surfaces this model should be offered on (e.g. Studio,
   * Freemode). Empty means the model is available on all surfaces.
   *
   * @generated from field: repeated creativefabrica.common.v1.surface.v1.Surface surfaces = 7;
   */
  surfaces?: SurfaceJson[];

  /**
   * One-line marketing description for the model picker UI.
   *
   * @generated from field: string short_description = 8;
   */
  shortDescription?: string;

  /**
   * Public/marketing name (e.g. "Nano Banana 2"), distinct from the internal
   * display_name (e.g. "Gemini Flash 3.1").
   *
   * @generated from field: string public_model_name = 9;
   */
  publicModelName?: string;

  /**
   * Unset when this model cannot be targeted by the shared Prompt Builder.
   *
   * @generated from field: creativefabrica.preset.v1.PromptBuilderSupport prompt_builder = 10;
   */
  promptBuilder?: PromptBuilderSupportJson;

  /**
   * coming_soon marks a pre-launch model that is listed for display (e.g. a
   * "coming soon" badge in a picker) but cannot generate yet: every generation
   * request naming it fails with INVALID_ARGUMENT. Cost quotes and
   * capabilities still resolve. Only returned when
   * ListModelsRequest.include_coming_soon is set.
   *
   * @generated from field: bool coming_soon = 11;
   */
  comingSoon?: boolean;
};

/**
 * Describes the message creativefabrica.preset.v1.CatalogModel.
 * Use `create(CatalogModelSchema)` to create a new message.
 */
export const CatalogModelSchema: GenMessage<CatalogModel, {jsonType: CatalogModelJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 12);

/**
 * PromptBuilderSupport is deliberately lightweight so the model catalog can
 * advertise discovery without embedding the shared form configuration in every
 * model. Presence is the enable signal.
 *
 * @generated from message creativefabrica.preset.v1.PromptBuilderSupport
 */
export type PromptBuilderSupport = Message<"creativefabrica.preset.v1.PromptBuilderSupport"> & {
  /**
   * @generated from field: bool supports_text_input = 1;
   */
  supportsTextInput: boolean;

  /**
   * @generated from field: bool supports_image_input = 2;
   */
  supportsImageInput: boolean;

  /**
   * Zero means image input is unsupported.
   *
   * @generated from field: int32 max_images = 3;
   */
  maxImages: number;
};

/**
 * PromptBuilderSupport is deliberately lightweight so the model catalog can
 * advertise discovery without embedding the shared form configuration in every
 * model. Presence is the enable signal.
 *
 * @generated from message creativefabrica.preset.v1.PromptBuilderSupport
 */
export type PromptBuilderSupportJson = {
  /**
   * @generated from field: bool supports_text_input = 1;
   */
  supportsTextInput?: boolean;

  /**
   * @generated from field: bool supports_image_input = 2;
   */
  supportsImageInput?: boolean;

  /**
   * Zero means image input is unsupported.
   *
   * @generated from field: int32 max_images = 3;
   */
  maxImages?: number;
};

/**
 * Describes the message creativefabrica.preset.v1.PromptBuilderSupport.
 * Use `create(PromptBuilderSupportSchema)` to create a new message.
 */
export const PromptBuilderSupportSchema: GenMessage<PromptBuilderSupport, {jsonType: PromptBuilderSupportJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 13);

/**
 * ModalityOutput pairs a supported modality with the output type it produces.
 *
 * @generated from message creativefabrica.preset.v1.ModalityOutput
 */
export type ModalityOutput = Message<"creativefabrica.preset.v1.ModalityOutput"> & {
  /**
   * @generated from field: creativefabrica.preset.v1.Modality modality = 1;
   */
  modality: Modality;

  /**
   * @generated from field: creativefabrica.preset.v1.OutputType output_type = 2;
   */
  outputType: OutputType;
};

/**
 * ModalityOutput pairs a supported modality with the output type it produces.
 *
 * @generated from message creativefabrica.preset.v1.ModalityOutput
 */
export type ModalityOutputJson = {
  /**
   * @generated from field: creativefabrica.preset.v1.Modality modality = 1;
   */
  modality?: ModalityJson;

  /**
   * @generated from field: creativefabrica.preset.v1.OutputType output_type = 2;
   */
  outputType?: OutputTypeJson;
};

/**
 * Describes the message creativefabrica.preset.v1.ModalityOutput.
 * Use `create(ModalityOutputSchema)` to create a new message.
 */
export const ModalityOutputSchema: GenMessage<ModalityOutput, {jsonType: ModalityOutputJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 14);

/**
 * @generated from message creativefabrica.preset.v1.CalculateModelCostRequest
 */
export type CalculateModelCostRequest = Message<"creativefabrica.preset.v1.CalculateModelCostRequest"> & {
  /**
   * Model name from ListModels, e.g. "seedance_v2".
   *
   * @generated from field: string model = 1;
   */
  model: string;

  /**
   * Option values keyed by option name as declared in
   * AIModelCapabilities.input_options. Every pricing-relevant option
   * (pricing_inputs.options) is required; extra options are validated against
   * the model's schema but do not affect the price. Static-priced models
   * ignore this field.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> options = 2;
   */
  options: { [key: string]: FieldValue };

  /**
   * Client-asserted metadata for input files, required only for models whose
   * price depends on input media (pricing_inputs.media). The same role may
   * appear multiple times when several files share it. The server never
   * probes files here — generation-time probing cross-checks these
   * assertions, so an honest quote always equals the charged amount.
   *
   * @generated from field: repeated creativefabrica.preset.v1.CostInputMedia input_media = 3;
   */
  inputMedia: CostInputMedia[];
};

/**
 * @generated from message creativefabrica.preset.v1.CalculateModelCostRequest
 */
export type CalculateModelCostRequestJson = {
  /**
   * Model name from ListModels, e.g. "seedance_v2".
   *
   * @generated from field: string model = 1;
   */
  model?: string;

  /**
   * Option values keyed by option name as declared in
   * AIModelCapabilities.input_options. Every pricing-relevant option
   * (pricing_inputs.options) is required; extra options are validated against
   * the model's schema but do not affect the price. Static-priced models
   * ignore this field.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> options = 2;
   */
  options?: { [key: string]: FieldValueJson };

  /**
   * Client-asserted metadata for input files, required only for models whose
   * price depends on input media (pricing_inputs.media). The same role may
   * appear multiple times when several files share it. The server never
   * probes files here — generation-time probing cross-checks these
   * assertions, so an honest quote always equals the charged amount.
   *
   * @generated from field: repeated creativefabrica.preset.v1.CostInputMedia input_media = 3;
   */
  inputMedia?: CostInputMediaJson[];
};

/**
 * Describes the message creativefabrica.preset.v1.CalculateModelCostRequest.
 * Use `create(CalculateModelCostRequestSchema)` to create a new message.
 */
export const CalculateModelCostRequestSchema: GenMessage<CalculateModelCostRequest, {jsonType: CalculateModelCostRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 15);

/**
 * CostInputMedia identifies one input file by role plus the metadata the
 * pricing formula needs.
 *
 * @generated from message creativefabrica.preset.v1.CostInputMedia
 */
export type CostInputMedia = Message<"creativefabrica.preset.v1.CostInputMedia"> & {
  /**
   * Role of the file as declared in input_role_constraints,
   * e.g. "sourceVideo", "firstFrame", "referenceVideo".
   *
   * @generated from field: string role = 1;
   */
  role: string;

  /**
   * @generated from field: creativefabrica.preset.v1.CostMediaMetadata metadata = 2;
   */
  metadata?: CostMediaMetadata | undefined;
};

/**
 * CostInputMedia identifies one input file by role plus the metadata the
 * pricing formula needs.
 *
 * @generated from message creativefabrica.preset.v1.CostInputMedia
 */
export type CostInputMediaJson = {
  /**
   * Role of the file as declared in input_role_constraints,
   * e.g. "sourceVideo", "firstFrame", "referenceVideo".
   *
   * @generated from field: string role = 1;
   */
  role?: string;

  /**
   * @generated from field: creativefabrica.preset.v1.CostMediaMetadata metadata = 2;
   */
  metadata?: CostMediaMetadataJson;
};

/**
 * Describes the message creativefabrica.preset.v1.CostInputMedia.
 * Use `create(CostInputMediaSchema)` to create a new message.
 */
export const CostInputMediaSchema: GenMessage<CostInputMedia, {jsonType: CostInputMediaJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 16);

/**
 * CostMediaMetadata carries the pricing-relevant properties of one input
 * file. Future pricing signals (frame rate, audio duration, page count, …)
 * are added as new optional fields here — never as new request fields — and
 * advertised per model via PricingMediaInput.required_metadata.
 *
 * @generated from message creativefabrica.preset.v1.CostMediaMetadata
 */
export type CostMediaMetadata = Message<"creativefabrica.preset.v1.CostMediaMetadata"> & {
  /**
   * @generated from field: optional int32 width_px = 1;
   */
  widthPx?: number | undefined;

  /**
   * @generated from field: optional int32 height_px = 2;
   */
  heightPx?: number | undefined;

  /**
   * @generated from field: optional int32 duration_seconds = 3;
   */
  durationSeconds?: number | undefined;

  /**
   * Frame rate rounded to the nearest integer (23.976 -> 24, 29.97 -> 30).
   * Advertised as "fps" in PricingMediaInput.required_metadata by models
   * priced on the source frame rate (the BytePlus enhance models when their
   * `fps` option is 0 = keep source).
   *
   * @generated from field: optional int32 fps = 4;
   */
  fps?: number | undefined;
};

/**
 * CostMediaMetadata carries the pricing-relevant properties of one input
 * file. Future pricing signals (frame rate, audio duration, page count, …)
 * are added as new optional fields here — never as new request fields — and
 * advertised per model via PricingMediaInput.required_metadata.
 *
 * @generated from message creativefabrica.preset.v1.CostMediaMetadata
 */
export type CostMediaMetadataJson = {
  /**
   * @generated from field: optional int32 width_px = 1;
   */
  widthPx?: number;

  /**
   * @generated from field: optional int32 height_px = 2;
   */
  heightPx?: number;

  /**
   * @generated from field: optional int32 duration_seconds = 3;
   */
  durationSeconds?: number;

  /**
   * Frame rate rounded to the nearest integer (23.976 -> 24, 29.97 -> 30).
   * Advertised as "fps" in PricingMediaInput.required_metadata by models
   * priced on the source frame rate (the BytePlus enhance models when their
   * `fps` option is 0 = keep source).
   *
   * @generated from field: optional int32 fps = 4;
   */
  fps?: number;
};

/**
 * Describes the message creativefabrica.preset.v1.CostMediaMetadata.
 * Use `create(CostMediaMetadataSchema)` to create a new message.
 */
export const CostMediaMetadataSchema: GenMessage<CostMediaMetadata, {jsonType: CostMediaMetadataJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 17);

/**
 * @generated from message creativefabrica.preset.v1.CalculateModelCostResponse
 */
export type CalculateModelCostResponse = Message<"creativefabrica.preset.v1.CalculateModelCostResponse"> & {
  /**
   * The coin price of one generation with these inputs.
   *
   * @generated from field: int64 coin_amount = 1;
   */
  coinAmount: bigint;

  /**
   * STATIC: fixed registry price, request inputs ignored.
   * DYNAMIC: computed from the echoed resolved_options and input media.
   *
   * @generated from field: creativefabrica.preset.v1.CoinPricingType pricing_type = 2;
   */
  pricingType: CoinPricingType;

  /**
   * The pricing-relevant option values the quote was computed from (explicit
   * values only — never defaults). Empty for static-priced models. Pass these
   * same values to the generate call to be charged exactly this amount.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> resolved_options = 3;
   */
  resolvedOptions: { [key: string]: FieldValue };
};

/**
 * @generated from message creativefabrica.preset.v1.CalculateModelCostResponse
 */
export type CalculateModelCostResponseJson = {
  /**
   * The coin price of one generation with these inputs.
   *
   * @generated from field: int64 coin_amount = 1;
   */
  coinAmount?: string;

  /**
   * STATIC: fixed registry price, request inputs ignored.
   * DYNAMIC: computed from the echoed resolved_options and input media.
   *
   * @generated from field: creativefabrica.preset.v1.CoinPricingType pricing_type = 2;
   */
  pricingType?: CoinPricingTypeJson;

  /**
   * The pricing-relevant option values the quote was computed from (explicit
   * values only — never defaults). Empty for static-priced models. Pass these
   * same values to the generate call to be charged exactly this amount.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> resolved_options = 3;
   */
  resolvedOptions?: { [key: string]: FieldValueJson };
};

/**
 * Describes the message creativefabrica.preset.v1.CalculateModelCostResponse.
 * Use `create(CalculateModelCostResponseSchema)` to create a new message.
 */
export const CalculateModelCostResponseSchema: GenMessage<CalculateModelCostResponse, {jsonType: CalculateModelCostResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_ai_provider, 18);

/**
 * @generated from service creativefabrica.preset.v1.AIProviderService
 */
export const AIProviderService: GenService<{
  /**
   * List all active providers with their models.
   * Returns lightweight metadata for discovery — no capabilities detail.
   *
   * @generated from rpc creativefabrica.preset.v1.AIProviderService.ListProviders
   */
  listProviders: {
    methodKind: "unary";
    input: typeof ListProvidersRequestSchema;
    output: typeof ListProvidersResponseSchema;
  },
  /**
   * Get the full capabilities of a specific model.
   * Used by admin tooling to prefill preset model configs from the model's
   * general options and constraints (the superset that presets narrow from).
   *
   * @generated from rpc creativefabrica.preset.v1.AIProviderService.GetModelCapabilities
   */
  getModelCapabilities: {
    methodKind: "unary";
    input: typeof GetModelCapabilitiesRequestSchema;
    output: typeof GetModelCapabilitiesResponseSchema;
  },
  /**
   * List all models with their full capabilities inline, optionally filtered.
   * Used by the FE to discover models and what they produce in a single call —
   * no per-model GetModelCapabilities round-trips. Set output_type to return
   * only models that produce that output (e.g. video), or modality for a
   * narrower filter. Leave the filter unset to get everything.
   *
   * @generated from rpc creativefabrica.preset.v1.AIProviderService.ListModels
   */
  listModels: {
    methodKind: "unary";
    input: typeof ListModelsRequestSchema;
    output: typeof ListModelsResponseSchema;
  },
  /**
   * Calculate the coin cost of a single direct (preset-less) generation
   * before submitting it. Call it uniformly for every model: static-priced
   * models return their fixed amount and ignore options/input_media, while
   * dynamic-priced models compute the price from the pricing-relevant inputs
   * declared in AIModelCapabilities.pricing_inputs.
   *
   * Pricing-relevant inputs must be supplied explicitly — model defaults are
   * never applied here. A missing or invalid pricing input fails with
   * INVALID_ARGUMENT carrying a creativefabrica.errors.v1.Error detail of
   * type ERROR_TYPE_VALIDATION listing every violation.
   *
   * Example — option-priced model (seedance_v2):
   *   { "model": "seedance_v2",
   *     "options": {
   *       "duration_seconds": {"integerValue": "10"},
   *       "resolution":       {"stringValue": "1080p"},
   *       "aspect_ratio":     {"stringValue": "16:9"} } }
   *   → { "coinAmount": "20180",
   *       "pricingType": "COIN_PRICING_TYPE_DYNAMIC",
   *       "resolvedOptions": { ...echo of the three options... } }
   *
   * Example — static-priced model:
   *   { "model": "gemini_pro_3" }
   *   → { "coinAmount": "3750", "pricingType": "COIN_PRICING_TYPE_STATIC" }
   *
   * Example — input-media-priced model (happy_horse_v1_video_editing is
   * billed on the source video's duration at the chosen resolution):
   *   { "model": "happy_horse_v1_video_editing",
   *     "options": {"resolution": {"stringValue": "1080p"}},
   *     "inputMedia": [{"role": "sourceVideo",
   *                     "metadata": {"durationSeconds": 12}}] }
   *
   * @generated from rpc creativefabrica.preset.v1.AIProviderService.CalculateModelCost
   */
  calculateModelCost: {
    methodKind: "unary";
    input: typeof CalculateModelCostRequestSchema;
    output: typeof CalculateModelCostResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_preset_v1_ai_provider, 0);

